import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";


export default function TopFinancingOptions2025() {
  return (
    <div className="bg-white text-[#0a2545]">
      {/* HERO SECTION */}
      <section
        className="relative h-[60vh] flex items-center justify-center text-center text-white"
        style={{
          backgroundImage:
            "linear-gradient(rgba(10,37,69,0.6), rgba(13,94,99,0.6)), url('/bl2.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="px-6"
        >
          <h1 className="text-5xl font-extrabold drop-shadow-lg">
            Top Financing Options in Canada (2025)
          </h1>
          <p className="mt-4 text-lg text-gray-200 max-w-2xl mx-auto">
            Explore the most flexible and affordable car financing plans that
            Canadians can benefit from this year.
          </p>
        </motion.div>
      </section>

      {/* BLOG BODY */}
      <section className="max-w-5xl mx-auto py-16 px-6 leading-relaxed">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-3xl font-bold mb-6"
        >
          Why Financing Matters More Than Ever
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="text-gray-700 mb-8"
        >
          With rising living costs and fluctuating interest rates, more Canadians
          are turning to smart car financing solutions. The year 2025 has seen
          innovative programs that help buyers with all kinds of credit
          histories secure affordable payments without the stress of bank
          restrictions.
        </motion.p>

        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-3xl font-bold mb-6"
        >
          Top Financing Programs to Consider
        </motion.h2>

        {/* CARD GRID */}
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {/* Program 1 */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="bg-gradient-to-br from-[#0a2545] to-[#0d5e63] text-white p-8 rounded-3xl shadow-lg hover:shadow-teal-400/50 transition"
          >
            <h3 className="text-2xl font-semibold mb-3">
              1. In-House Financing (Yes Auto Advantage)
            </h3>
            <p className="text-gray-200 leading-relaxed">
              Ideal for those with limited or poor credit history. Instead of
              relying on banks, our team offers in-house financing directly
              through <span className="text-teal-400 font-semibold">Yes Auto</span>,
              making it faster, easier, and more flexible. Tailored terms ensure
              payments fit your lifestyle and income.
            </p>
          </motion.div>

          {/* Program 2 */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="bg-gradient-to-br from-[#0b3b52] to-[#0e6b63] text-white p-8 rounded-3xl shadow-lg hover:shadow-teal-400/50 transition"
          >
            <h3 className="text-2xl font-semibold mb-3">
              2. Low-Interest Bank Loans
            </h3>
            <p className="text-gray-200 leading-relaxed">
              For buyers with stable income and a good score (above 680), major
              banks in Canada offer competitive rates. These loans are ideal if
              you want a structured repayment plan and can make a higher
              down-payment upfront.
            </p>
          </motion.div>

          {/* Program 3 */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="bg-gradient-to-br from-[#0b3b52] to-[#0f6f73] text-white p-8 rounded-3xl shadow-lg hover:shadow-teal-400/50 transition"
          >
            <h3 className="text-2xl font-semibold mb-3">
              3. Lease-to-Own Programs
            </h3>
            <p className="text-gray-200 leading-relaxed">
              These hybrid plans let you lease a car for a few years while making
              gradual payments toward ownership. They’re excellent for those who
              want lower monthly costs while still working toward full
              ownership.
            </p>
          </motion.div>

          {/* Program 4 */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            className="bg-gradient-to-br from-[#0a2545] to-[#0d5e63] text-white p-8 rounded-3xl shadow-lg hover:shadow-teal-400/50 transition"
          >
            <h3 className="text-2xl font-semibold mb-3">
              4. Credit Rebuilding Auto Loans
            </h3>
            <p className="text-gray-200 leading-relaxed">
              Designed for buyers who faced financial hardship or bankruptcy.
              These loans allow you to rebuild your credit with consistent,
              manageable payments. Each on-time payment helps improve your score
              while keeping you on the road.
            </p>
          </motion.div>
        </div>

        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-3xl font-bold mb-6"
        >
          How to Choose the Right Plan for You
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
          className="text-gray-700 mb-8"
        >
          Every buyer’s financial situation is unique. Start by understanding
          your monthly affordability and credit profile. Then, talk with a Yes
          Auto expert who can help match you to the program that provides the
          best long-term value and fits your lifestyle.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6 }}
          className="bg-gradient-to-r from-[#0a2545] to-[#0d5e63] text-white p-10 rounded-3xl shadow-lg"
        >
          <h3 className="text-2xl font-semibold mb-3">⭐ Quick Summary</h3>
          <ul className="list-disc list-inside space-y-2 text-gray-200">
            <li>In-house financing gives flexibility with low barriers.</li>
            <li>Bank loans reward strong credit with lower rates.</li>
            <li>Lease-to-own is great for lower monthly costs.</li>
            <li>Rebuild-credit loans help you grow your credit safely.</li>
          </ul>
        </motion.div>

        {/* CTA SECTION */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8 }}
          className="mt-16 text-center"
        >
          <p className="text-gray-700 mb-6">
            Ready to explore your personalized car financing options?
          </p>
          <Link
            to="/financing"
            className="inline-block bg-teal-400 text-[#0a2545] px-10 py-4 rounded-full font-semibold shadow-lg hover:scale-[1.05] transition"
          >
            Apply for Financing
          </Link>
        </motion.div>
      </section>
      </div>

  );
}
